<template>
  <Transition
    enter-active-class="transition-all duration-500 ease-out"
    enter-from-class="translate-y-full opacity-0"
    enter-to-class="translate-y-0 opacity-100"
    leave-active-class="transition-all duration-300 ease-in"
    leave-from-class="translate-y-0 opacity-100"
    leave-to-class="translate-y-full opacity-0"
  >
    <div
      v-if="deal"
      class="fixed bottom-20 left-4 right-4 z-40 max-w-md mx-auto"
    >
      <div class="relative bg-gradient-to-r from-amber-500 via-orange-500 to-red-500 rounded-2xl p-[2px] shadow-2xl shadow-orange-500/30">
        <div class="bg-gray-900 rounded-2xl p-4 relative overflow-hidden">
          <!-- Animated background -->
          <div class="absolute inset-0 opacity-10">
            <div class="absolute inset-0 bg-gradient-to-r from-amber-400/20 to-red-400/20 animate-pulse"></div>
          </div>

          <!-- Close button -->
          <button
            @click="dismiss"
            class="absolute top-2 right-2 w-6 h-6 flex items-center justify-center text-white/50 hover:text-white rounded-full"
          >✕</button>

          <!-- Progress bar -->
          <div class="mb-3">
            <div class="flex justify-between text-xs text-amber-300 mb-1">
              <span>{{ deal.currentCount }}/{{ deal.totalParticipants }} haben {{ deal.category }} gewählt</span>
              <span>Noch {{ deal.neededCount }}!</span>
            </div>
            <div class="h-2 bg-white/10 rounded-full overflow-hidden">
              <div
                class="h-full bg-gradient-to-r from-amber-400 to-orange-500 rounded-full transition-all duration-1000"
                :style="{ width: `${(deal.currentCount / deal.totalParticipants) * 100}%` }"
              ></div>
            </div>
          </div>

          <!-- Content -->
          <div class="relative z-10">
            <div class="flex items-start gap-3">
              <div class="text-3xl animate-bounce">🔓</div>
              <div class="flex-1">
                <h3 class="text-white font-bold text-lg leading-tight">{{ deal.headline }}</h3>
                <p class="text-amber-200 text-sm mt-1">{{ deal.description }}</p>
              </div>
            </div>

            <!-- Discount badge -->
            <div class="flex items-center justify-between mt-3">
              <div class="bg-green-500/20 text-green-400 px-3 py-1 rounded-full text-sm font-bold">
                -{{ deal.discountPercentage }}% für alle!
              </div>
              <button
                @click="exploreDeal"
                class="bg-gradient-to-r from-amber-400 to-orange-500 text-gray-900 px-5 py-2 rounded-xl font-bold text-sm hover:scale-105 transition-transform"
              >{{ deal.cta || 'Jetzt entdecken' }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { computed } from 'vue'
import { useGamificationStore } from '@/stores/gamification'

const emit = defineEmits(['explore-category', 'dismiss'])
const store = useGamificationStore()

const deal = computed(() => store.activeDeal)

function dismiss() {
  store.dismissDeal()
  emit('dismiss')
}

function exploreDeal() {
  emit('explore-category', deal.value?.category)
}
</script>
